/**
 * Pure utility functions for mapping GitHub labels to internal roadmap types.
 * Extracted for testability (no React/Supabase dependencies).
 */

export interface GitHubLabel {
  name: string;
  color: string;
  description?: string;
}

export type RoadmapStatus = 'idee' | 'geplant' | 'in_arbeit' | 'review' | 'human_feedback' | 'fertig';
export type RoadmapPrioritaet = 'critical' | 'high' | 'medium' | 'low';
export type RoadmapTyp = 'feature' | 'bug' | 'refactor' | 'research' | 'docs';

export function mapLabelsToStatus(labels: GitHubLabel[]): RoadmapStatus {
  const names = labels.map(l => l.name);
  // human-feedback = Andreas needs to make a decision → distinct filterable status
  if (names.includes('human-feedback') || names.includes('status:feedback')) return 'human_feedback';
  if (names.includes('status:review') || names.includes('ready-to-merge')) return 'review';
  if (names.includes('status:in-progress') || names.includes('needs-further-dev')) return 'in_arbeit';
  // agent:claude-code means Claude is actively working on it → in_arbeit
  if (names.includes('agent:claude-code')) return 'in_arbeit';
  if (names.includes('status:ready')) return 'geplant';
  if (names.includes('status:blocked')) return 'geplant';
  return 'idee';
}

export function mapLabelsToPrioritaet(labels: GitHubLabel[]): RoadmapPrioritaet {
  const names = labels.map(l => l.name);
  if (names.includes('priority:critical')) return 'critical';
  if (names.includes('priority:high')) return 'high';
  if (names.includes('priority:medium')) return 'medium';
  if (names.includes('priority:low')) return 'low';
  return 'medium';
}

export function mapLabelsToTyp(labels: GitHubLabel[]): RoadmapTyp {
  const names = labels.map(l => l.name);
  if (names.includes('type:bug')) return 'bug';
  if (names.includes('type:refactor')) return 'refactor';
  if (names.includes('type:research')) return 'research';
  if (names.includes('type:docs')) return 'docs';
  return 'feature';
}

export function mapLabelsToAgent(labels: GitHubLabel[]): 'manus' | 'claude-code' | 'unassigned' {
  const names = labels.map(l => l.name);
  if (names.includes('agent:claude-code')) return 'claude-code';
  if (names.includes('agent:manus')) return 'manus';
  return 'unassigned';
}
